import React from 'react';
import { IconProps } from '../IconProps';
const SvgStackPerspective = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M2.251 13.306A1.252 1.252 0 011 12.056V5.944a1.252 1.252 0 011.645-1.186l.842.281a.75.75 0 01-.475 1.423l-.513-.17v5.418l.513-.17a.75.75 0 11.475 1.422l-.842.281a1.24 1.24 0 01-.394.064zM6.25 15.25A1.25 1.25 0 015.001 14V4a1.248 1.248 0 011.73-1.154l.808.336a.75.75 0 01-.577 1.385l-.461-.192v9.25l.461-.192a.75.75 0 01.577 1.385l-.808.336a1.262 1.262 0 01-.481.096zM15.983 3.551l-5.209-2.405A1.25 1.25 0 009 2.281V15.72c0 .428.215.822.576 1.053a1.248 1.248 0 001.198.082l5.209-2.404A1.755 1.755 0 0017 12.861v-7.72c0-.68-.399-1.305-1.017-1.59z"
      fill="#0D0300"
    />
  </svg>
);
export default SvgStackPerspective;
